import React from "react";
import ContentWrapper from "./content-wrapper.component";

const ContentWrapperContainer = (props: any) => {
  return <ContentWrapper {...props} />;
};

export default ContentWrapperContainer;
